import { useContext } from 'react';

import { AnalyticsContext } from '../AnalyticsProvider';

export function useAnalytics() {
	const context = useContext(AnalyticsContext);
	return context;
}
